import Mosaic from 'mosaic-framework';

import '../components/navigation-bar';
import '../components/footer';
import '../components/round-button';

import '../styles/docs.less';


export default new Mosaic({
    name: 'mosaic-page',
    created() {
        window.scrollTo({ top: 0 });

        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'block';

        if(menubtn.onclick) return;

        menubtn.onclick = () => {
            const menu = document.getElementById('doc-menu');
            menu.style.transform = 'translateX(0%)';
        }
    },
    willDestroy() {
        const menubtn = document.getElementById('menu-button');
        menubtn.style.display = 'none';
    },
    view() {
        return html`<div class='doc-page'>
            <navigation-bar></navigation-bar>
            
            <h1 class='section-title' tabindex='0'>🎨What is Mosaic?</h1>
            <p class='section-text' tabindex='0'>
                Mosaic is a declarative JavaScript library for building user interfaces
                through the use of Web Components. By leveraging the custom elements API
                and other native JavaScript features, Mosaic becomes a very powerful UI 
                library because it can be incrementally adopted into any existing web app.
                Custom elements work like regular HTML tags, so there will be no problem
                including them with another library like React. Mosaic also uses Tagged
                Template Literals for writing component views, which means no compiler
                is needed to transform your JavaScript code!
            </p>

            <h1 class='section-title' tabindex='0'>What is a Mosaic Component?</h1>
            <p class='section-text' tabindex='0'>
                Components in Mosaic work slightly differently than components in React
                or Vue. Mosaic Components are really just extensions of the HTMLElement
                class that is built into JavaScript, but with a few extra properties.
                By extending the HTMLElement class, Mosaic can take advantage of the
                already existing HTML attributes and properties to help with rendering.
                In addition, it allows you to use Mosaic components as custom elements.
            </p>
            <p class='section-text' tabindex='0'>
                Since Mosaics are just extensions of HTMLElements, you can interact with
                them as if they were regular DOM nodes, because they are! At the end of the
                day, a Mosaic is just another DOM node like ${"<input>"} or ${"<div>"}, but
                with extra properties on it that make it a Mosaic. For example, each Mosaic
                comes with a "data" property that is an "Observable" type (more on this in
                a different section). If you wanted to change the data on a component that
                is already in the DOM, you can simply find the node through 
                "document.getElementById" or something similar and update its data property
                directly. Note, however, that only Mosaics will have such properties, so you
                may want to check if it exists on the DOM node when you query first to make
                sure that it is, in fact, a Mosaic and not just a regular HTML tag.
            </p>

            <h1 class='section-title' tabindex='0'>Use Cases</h1>
            <p class='section-text' tabindex='0'>
                Mosaic is great for all kinds of UI development. Again, the use of Web
                Components makes it very flexible and unopinionated. First, Mosaic is great
                for creating design systems. Because of its ability to use the Shadow DOM
                to encapsulate styles, Mosaic makes it very easy to create a reusable component
                library for your company's design system.
            </p>
            <p class='section-text' tabindex='0'>
                As mentioned before, Mosaic is unopinionated. This means that you can easily
                include it in your existing web apps without breaking your tech stack. Web
                Components work like regular HTML tags, and Mosaic is just an extension of them.
                It is this feature of Mosaic that makes it work very nicely with other libraries
                like React and Vue.
            </p>
            <p class='section-text' tabindex='0'>
                More than just being unopinionated, Mosaic can also be used to craft the entire
                backbone of your web app. Although it is called a library, Mosaic could also be
                referred to as a framework as it contains a built-in, client-side router and a
                global state manager that can be used to create the entire front-end of a web app.
            </p>

            <br>
            <p class='section-text' tabindex='0' style="text-align: center;">
                Click below to continue to the next section!
            </p>

            <div style="text-align: center;">
                <round-button onclick='${() => this.router.send('/initialization')}'>
                    Initialization
                    <ion-icon name="arrow-round-forward"></ion-icon>
                </round-button>
            </div>

            <app-footer></app-footer>
        </div>`
    }
});